import { TemplateEngine } from "../shared/utils/TemplateEngine.js";
import { PolizasService } from "../shared/services/PolizasService.js";
import { EstadoService } from "../shared/services/EstadoService.js";
import { Navbar } from "../shared/components/navbar/Navbar.js";
import { esc } from "../shared/utils/Formato.js";
import detalleTemplate from "./templates/poliza-detalle.html?raw";

const app = () => document.getElementById("app");

const navbarDetalle = (titulo = "Detalle de póliza", sobretitulo = "Mi póliza") =>
  Navbar.render({ volver: true, titulo, sobretitulo });

// La revalidacion vuelve tarde: si el usuario ya volvio al home o abrio otra poliza, no se pinta.
const sigueEnLaPoliza = (id) => {
  const [path, query] = window.location.hash.slice(1).split("?");
  return path === "poliza" && new URLSearchParams(query || "").get("id") === String(id);
};

export const PolizaController = {
  render: async (params) => {
    const id = params?.get("id");
    if (!id) {
      window.location.hash = "home";
      return;
    }

    app().innerHTML =
      navbarDetalle() +
      '<div class="fx-cargando"><div class="spinner-border text-primary" role="status"></div>' +
      '<span class="small">Cargando la póliza...</span></div>';
    Navbar.bind();

    try {
      const poliza = await PolizasService.obtener(id);
      PolizaController.pintar(poliza);

      // Revalidacion en segundo plano, igual que en el home. Si el usuario ya paso por el home
      // hace menos de VITE_SELLO_TTL, esto ni toca la red.
      EstadoService.revalidar(async () => {
        const fresca = await PolizasService.obtener(id, { forceRefresh: true });
        if (!sigueEnLaPoliza(id)) return;
        PolizaController.pintar(fresca, { conservarScroll: true });
      });
    } catch (error) {
      console.error("Error cargando la póliza:", error);
      app().innerHTML =
        navbarDetalle() +
        '<div class="fx-pantalla mt-4"><div class="alert alert-danger">' +
        '<i class="fas fa-triangle-exclamation me-2"></i>' +
        esc(error.message || "No pudimos cargar la póliza.") +
        '</div><a class="btn btn-outline-primary w-100" href="#home">' +
        '<i class="fas fa-arrow-left me-2"></i>Volver a mis pólizas</a></div>';
      Navbar.bind();
    }
  },

  /**
   * @param {object} [opciones]
   * @param {boolean} [opciones.conservarScroll] Tras un repintado por datos nuevos: si el usuario
   *   estaba mirando las cuotas, no tiene por que volver al principio de la pantalla.
   */
  pintar: (poliza, { conservarScroll = false } = {}) => {
    const y = conservarScroll ? window.scrollY : 0;
    const contenido = TemplateEngine.render(detalleTemplate, poliza);

    app().innerHTML = navbarDetalle(poliza.Titulo, poliza.Etiqueta) + contenido;
    Navbar.bind();
    if (y) window.scrollTo(0, y);
  },
};
